/* ===========================================================================
   THE TWO STOPS, ON A PRODUCT PAGE
   In the bag the bar reports what has been earned. Here it previews what this
   order would earn, so it watches the two things the customer is choosing:
   how many, and whether to subscribe. Nothing is committed until Add to bag.
   =========================================================================== */
(function () {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function init(root) {
    if (root.dataset.fcBuyInit === '1') return;
    root.dataset.fcBuyInit = '1';

    var saving = parseInt(root.dataset.saving, 10) || 0;
    var ship = parseInt(root.dataset.ship, 10) || 0;
    var planId = root.dataset.plan || '';
    /* The ten percent belongs to the single box alone. A set is already past
       the two box threshold, so subscribing to one buys free shipping and
       nothing else, and the bar has one stop rather than two. */
    var singleBox = root.dataset.singleBox === 'true';
    /* Australia pays a flat shipping charge, so this component must never promise
       free shipping there. Subscribing still buys the discount. */
    var noFree = root.dataset.noFreeShip === 'true';
    var pct = parseInt(root.dataset.pct, 10) || 0;
    var unit = parseInt(root.dataset.price, 10) || 0;

    var fill = root.querySelector('.fc-ship__fill');
    var stopOne = root.querySelector('.fc-ship__stop--one');
    var stopTwo = root.querySelector('.fc-ship__stop--two');
    var msg = root.querySelector('[data-fc-msg]');
    var planField = root.querySelector('[data-fc-plan-field]');
    var subLabel = root.querySelector('[data-fc-sub-label]');
    var totalEl = root.querySelector('[data-fc-total]');

    /* Scoped to this product's own form. The bag drawer has a quantity input of
       its own for whatever is already in the bag, and reaching for the first one
       on the page found that instead, so the bar reported the bag rather than
       the choice being made. */
    var scope = root.closest('.product__info-container') || document;

    function qty() {
      var input = scope.querySelector('.product-form__quantity .quantity__input')
               || scope.querySelector('.quantity__input');
      var n = input ? parseInt(input.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }

    function subscribed() {
      var on = root.querySelector('[data-fc-mode][value="sub"]');
      return !!(on && on.checked);
    }

    function paint() {
      var sub = subscribed();
      /* On a set, one of anything already clears the threshold. On the single
         box it is however many boxes were chosen. */
      var boxes = singleBox ? qty() : 2;

      /* Two boxes is two boxes however it was arrived at, so the single box at
         a quantity of two is the same offer as a set: the discount is gone and
         the postage is what subscribing buys. The whole panel changes with it,
         not only the sentence. */
      var onDiscount = singleBox && boxes < 2;

      /* free shipping is earned by subscribing at two boxes or more, so a
         one time order never fills the bar however many boxes it holds */
      var free = sub && boxes >= 2;
      var width = !sub ? 0 : (boxes >= 2 ? 100 : 50);

      fill.style.width = width + '%';
      if (stopOne) stopOne.classList.toggle('is-hit', sub);
      stopTwo.classList.toggle('is-hit', free);
      root.classList.toggle('is-on', free);
      root.classList.toggle('is-subscribed', sub);
      root.classList.toggle('fc-ship--one-stop', !onDiscount);

      if (subLabel) {
        /* On the single box the offer is a percentage, so it is named as one
           with the money in brackets. Past one box it becomes the postage,
           which is only ever a figure. */
        subLabel.textContent = onDiscount && pct
          ? 'Subscribe and save ' + pct + '% (' + money(saving) + ')'
          : 'Subscribe and save ' + money(onDiscount || noFree ? saving : ship);
      }

      if (noFree) {
        msg.innerHTML = sub
          ? 'You are subscribed and saving <strong>' + money(saving) + '</strong> on every delivery.'
          : 'Subscribe and save <strong>' + money(saving) + '</strong> on every delivery. Pause or cancel any time.';
      } else if (!onDiscount) {
        msg.innerHTML = sub
          ? '<strong>Free shipping.</strong> You are saving ' + money(ship) + '.'
          : 'Subscribe and this order ships free, which saves <strong>' + money(ship) + '</strong>.';
      } else if (sub) {
        /* What the next box is actually worth. Going from one box to two trades
           the discount for the postage, so the gain is the difference between
           them, not the postage on its own. Saying "save $8.00" when $1.40 is
           being given up overstates it by the amount of the discount. */
        msg.innerHTML = 'You are saving <strong>' + money(saving) + '</strong>. Add one more box and you save <strong>' + money(ship - saving) + '</strong> more, because shipping is free instead.';
      } else {
        msg.innerHTML = 'Subscribe and save ' + money(saving) + ' on this box. Add one more and shipping is free instead.';
      }

      /* What it comes to, shipping included. Named here rather than left for
         checkout, because postage discovered at the last step is the thing
         people abandon over. */
      if (totalEl && unit) {
        var goods = unit * qty();
        if (onDiscount && sub) goods -= saving;
        var post = free ? 0 : ship;
        totalEl.innerHTML = noFree
          ? '<strong>' + money(goods) + '</strong> total, plus shipping at checkout.'
          : free
          ? '<strong>' + money(goods) + '</strong> total, shipping included.'
          : '<strong>' + money(goods + post) + '</strong> total. ' +
            money(goods) + ' plus ' + money(post) + ' shipping.';
      }

      /* a disabled field is not submitted, which is how one time stays one time */
      if (planField) {
        planField.disabled = !sub;
        planField.value = sub ? planId : '';
      }
    }

    root.querySelectorAll('[data-fc-mode]').forEach(function (r) {
      r.addEventListener('change', paint);
    });

    scope.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.quantity')) paint();
    });
    scope.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(paint, 60);
    });

    paint();
  }

  function boot() { document.querySelectorAll('[data-fc-ship-preview]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
